import React, { useState, useEffect } from "react";
import Layout from "../components/Layout";
import PersonaSelect from "../components/PersonaSelect";
import { api } from "../lib/api";

export default function Campanhas() {
  const [pid, setPid] = useState("");
  const [camps, setCamps] = useState([]);
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState("");
  const [msg, setMsg] = useState("");

  const reload = () => api.listCampaigns(pid).then(setCamps).catch((e) => setErr(String(e.message)));
  useEffect(() => {
    if (!pid) { setCamps([]); return; }
    reload();
  }, [pid]); // eslint-disable-line

  const activate = async (id) => {
    setBusy(id); setErr(""); setMsg("");
    try { const r = await api.activateCampaign(id); setMsg(r.message); reload(); }
    catch (e) { setErr(String(e.message)); } finally { setBusy(""); }
  };

  return (
    <Layout>
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-2xl font-bold">Campanhas</h1>
          <p className="text-neutral-400 text-sm mt-1">Planos geointeligentes prontos para ativação, gerados por zona de intenção.</p>
        </div>
        <PersonaSelect value={pid} onChange={setPid} />
      </div>
      {err && <div className="mt-4 rounded-md bg-red-600/15 text-red-400 px-4 py-2 text-sm">{err}</div>}
      {msg && <div className="mt-4 rounded-md bg-emerald-600/15 text-emerald-400 px-4 py-2 text-sm">{msg}</div>}
      <div className="mt-6 space-y-3">
        {camps.map((c) => (
          <div key={c.id} className="rounded-lg border border-neutral-800 bg-neutral-900/50 p-4">
            <div className="flex justify-between items-start">
              <span className="font-medium text-sm">{c.objective}</span>
              <span className={"text-[10px] uppercase tracking-wide rounded px-2 py-0.5 " + (c.status === "activated" ? "bg-emerald-500/15 text-emerald-400" : "bg-amber-500/15 text-amber-400")}>{c.status}</span>
            </div>
            <div className="mt-2 text-xs text-neutral-400">Canal: {c.channel}</div>
            <div className="text-xs text-neutral-400">Orçamento: R${c.suggested_budget}/dia · {c.suggested_duration_days} dias</div>
            {c.offer && <div className="text-xs text-neutral-300 mt-2"><b>Oferta:</b> {c.offer}</div>}
            {c.main_copy && <div className="text-xs text-neutral-300 mt-1"><b>Copy:</b> {c.main_copy}</div>}
            {c.ad_variations?.length > 0 && (
              <ul className="mt-2 text-xs text-neutral-400 list-disc pl-4">
                {c.ad_variations.slice(0, 3).map((v, i) => <li key={i}>{v}</li>)}
              </ul>
            )}
            {c.status !== "activated" && (
              <button onClick={() => activate(c.id)} disabled={busy === c.id}
                className="mt-3 rounded-md bg-red-600 hover:bg-red-500 px-3 py-1.5 text-xs font-medium disabled:opacity-50">
                {busy === c.id ? "Ativando…" : "Ativar no Meta →"}
              </button>
            )}
          </div>
        ))}
        {pid && !camps.length && <div className="text-neutral-500 text-sm">Sem campanhas. Gere uma a partir de uma zona (aba Zonas de Intenção).</div>}
      </div>
    </Layout>
  );
}
